import script from "./ProductCardCalculator.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductCardCalculator.vue?vue&type=script&lang=ts&setup=true"

import "./ProductCardCalculator.vue?vue&type=style&index=0&id=2150c6c2&lang=scss"

const __exports__ = script;

export default __exports__